import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StatusStyle from '../../../shared/StatusStyle'

class ItemStatus extends Component {
    render() {
        return (
            <div className='ItemStatus'>
                <StatusStyle status={this.props.status}/>
            </div>
        )
    }
}

ItemStatus.propTypes = {
    status: PropTypes.string
}

export default ItemStatus
